import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconWalletComponent } from "./med-icon-wallet.component";

@NgModule({
  declarations: [
    MedIconWalletComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconWalletComponent,
  ],
})
export class MedIconWalletModule { }
